export const getEmissionType: (arg0: boolean, arg1: boolean, arg2: string | undefined, arg3?: boolean) => string = (
  isEmissionsChart,
  isConsumption,
  subTabName,
  isEstimate,
) => isEmissionsChart ? `${subTabName}Based${isEstimate ? "Estimate" : "Emission"}` : isConsumption ? "consumption" : "amount";

export const generateXAxisCategories: (arg0: any[], arg1: string) => string[] = (
  data,
  dateRangeType,
) => Array.from(new Set(data
  .filter((entry: any) => {
    // Filter out entries with missing required fields
    if (dateRangeType === "MONTHLY") {
      return entry.year !== null && entry.year !== undefined && entry.month;
    }
    if (dateRangeType === "QUARTERLY") {
      return entry.fiscalYear !== null && entry.fiscalYear !== undefined &&
        entry.fiscalYearQuarter !== null && entry.fiscalYearQuarter !== undefined;
    }
    return entry.fiscalYear !== null && entry.fiscalYear !== undefined;
  })
  .map((entry: any) =>
    dateRangeType === "MONTHLY"
      ? entry.month + entry.year.replace("20", " '")
      : dateRangeType === "QUARTERLY"
        ? (`Q${entry.fiscalYearQuarter}`).concat(entry.fiscalYear.replace("20", " '")).concat(" FY")
        : entry.fiscalYear.concat(" FY")
  )
));

export const generateDataCategories: (arg0: any[], arg1: string, arg2: string) => Record<string, any[]> = (
  data,
  emissionType,
  type,
) => data.reduce((acc: any, entry: any) => {
  if (!acc[entry[type]]) {
    acc[entry[type]] = [];
  }
  acc[entry[type]].push({
    ...entry,
    [emissionType]: entry[emissionType] ?? 0,
  });
  return acc;
}, {});

export const generateXAxisData: (arg0: Record<string, any[]>, arg1: string[], arg2: string, arg3: string) => Record<string, any[]> = (
  dataTypeArr,
  sortedXAxisCategoriesGenerated,
  dateRangeType,
  emissionType,
) => Object.keys(dataTypeArr).reduce((acc: any, arrKey: string) => {
  acc[arrKey] = sortedXAxisCategoriesGenerated.map((entry: string) => {
    const value = dataTypeArr[arrKey as keyof typeof dataTypeArr].find((item: any) => {
      if (dateRangeType === "MONTHLY") {
        return `${item.month} '${item.year?.substring(2, 4)}` === entry;
      }
      if (dateRangeType === "QUARTERLY") {
        return (
          item.fiscalYearQuarter === entry?.substring(1, 2) &&
          item.fiscalYear?.substring(2) === entry?.substring(4, 6)
        );
      }
      return item.fiscalYear === entry?.substring(0, 4);
    })?.[emissionType] ?? 0;
    return value;
  });
  return acc;
}, {});

